import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

export const StyledTextarea = styled.textarea`
    font-size: 16px;
    box-sizing: border-box;
    background-color: var(--color-white);
    border: 1px solid var(--gray200);
    color: var(--gray800);
    width: 100%;
    height: 92px;
    resize: none;
    padding: 8px;
    box-shadow: inset var(--shadow-2);

    &:disabled {
        color: var(--gray700);
        pointer-events: none;
        box-shadow: initial;
    }

    ${(props) =>
        props.type === 'error' &&
        css`
            border: 1px solid var(--color-error-default);
            background-color: var(--red50);
        `}

    ${(props) =>
        props.type === 'success' &&
        css`
            border: 1px solid var(--color-success-default);
            background-color: var(--green50);
        `}

    ${(props) =>
        props.type === 'warning' &&
        css`
            border: 1px solid var(--color-warning-default);
            background-color: var(--yellow50);
        `}

    ${(props) =>
        props.type === 'missing' &&
        css`
            border: 1px solid var(--gray200);
            background-color: var(--color-white);
        `}

    &:not(:focus):not(:disabled) {
        ${(props) =>
            props.value &&
            css`
                border: 1px solid var(--gray800);
                color: var(--gray800);
                box-shadow: initial;
            `}
    }

    &:hover {
        ${(props) =>
            !props.value &&
            css`
                border: 1px solid var(--gray800);
                background: var(--gray50);
                box-shadow: initial;
                cursor: pointer;
            `}
    }

    &:active,
    &:focus {
        cursor: text;
        color: var(--blue400);
        border: 1px solid var(--blue400);
        box-shadow: var(--outline);
        outline: none;
    }
`;

const Textarea = ({ disabled = false, value = '', onChange, type, placeholder = '', ...props }) => {
    return <StyledTextarea onChange={onChange} value={value} disabled={disabled} type={type} placeholder={placeholder} {...props} />;
};

Textarea.propTypes = {
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    type: PropTypes.oneOf(['error', 'success', 'warning', 'missing']),
    value: PropTypes.string,
    placeholder: PropTypes.string,
};

export default Textarea;
